import { CONSTANTS } from '@/types/enum/constants'

const getIsUserStudents = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles.find(value => [CONSTANTS.ROLE_STUDENT_USER].find(role => role === value)) ||
  false

export default getIsUserStudents
